<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryAlertRuleByGroupIdList" :height="500">
    </Table>
  </div>
</template>
<script>
    var tableAlertRule = {}
    export default {
        name: 'TableAlertRule',
        data() {
            return {
                Name: '',
                modalLoading: false,
                columns: [
                    {
                        title: this.$t('alarms.common.alertRuleName'),
                        key: 'alertRuleName'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key:'stateName'
                    },
                    {
                        title: this.$t('alarms.common.monitorIndex'),
                        key: 'monitorIndexName'
                    },
                    {
                        title: this.$t('alarms.common.monitorIndex'),
                        key: 'alertRuleDesc'
                    },
                    {
                        title: this.$t('alarms.common.contact'),
                        key: 'contactNameList'
                    },
                    {
                        title: this.$t('alarms.common.scanType'),
                        key: 'scanTypeName'
                    }
                ],
                queryAlertRuleByGroupIdList: []
            }
        },
        beforeCreate: function () {
          tableAlertRule = this
        },
        mounted: function () {
          tableAlertRule.queryAlertRulesByGroupId();
        },
        methods: {
            queryAlertRulesByGroupId: function () {
              this.modalLoading=true;
              tableAlertRule.$api.alertRule.selectInstantiationByAlertRule('id', this.$route.query.id)
                  .then(res => {
                      this.queryAlertRuleByGroupIdList = res.data;
                      this.modalLoading = false
                  })

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rule_engine/TableAlertRule.vue